import { X } from "lucide-react";
import { CHANNEL_META } from "../lib/offersApi";

/**
 * Small modal: choose the channel of origin for a new offer.
 * Emits onSelected(channel) + closes.
 */
export default function NewOfferModal({ onClose, onSelected }) {
  const entries = [
    ["email_manual", "Email (incollata manualmente)"],
    ["phone", "Telefono"],
    ["whatsapp", "WhatsApp"],
    ["manual", "Manuale (griglia vuota)"],
    ["email_auto", "Email automatica (mailbox)"],
  ];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.4)" }}
      onClick={onClose}
      data-testid="new-offer-modal"
    >
      <div
        className="w-full max-w-md rounded-xl p-6"
        style={{
          background: "var(--bg-surface)",
          border: "1px solid var(--border-subtle)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <div
            className="font-semibold text-[16px]"
            style={{ color: "var(--text-primary)" }}
          >
            Da quale canale arriva la richiesta?
          </div>
          <button
            type="button"
            onClick={onClose}
            className="h-7 w-7 rounded flex items-center justify-center"
            style={{ color: "var(--text-muted)" }}
            data-testid="close-new-offer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="grid grid-cols-1 gap-2">
          {entries.map(([key, label]) => {
            const m = CHANNEL_META[key] || { icon: "?", label };
            const disabled = key === "email_auto";
            return (
              <button
                key={key}
                type="button"
                disabled={disabled}
                onClick={() => {
                  onSelected(key);
                  onClose();
                }}
                className="flex items-center gap-3 h-12 px-3 rounded-md text-left transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                style={{
                  border: "1px solid var(--border-default)",
                  background: "var(--bg-surface)",
                }}
                onMouseEnter={(e) => {
                  if (!disabled)
                    e.currentTarget.style.background = "var(--bg-subtle)";
                }}
                onMouseLeave={(e) => {
                  if (!disabled)
                    e.currentTarget.style.background = "var(--bg-surface)";
                }}
                data-testid={`channel-${key}`}
              >
                <span className="text-[20px]">{m.icon}</span>
                <div>
                  <div
                    className="text-[13px] font-medium"
                    style={{ color: "var(--text-primary)" }}
                  >
                    {label}
                  </div>
                  {disabled && (
                    <div
                      className="text-[10px]"
                      style={{ color: "var(--text-muted)" }}
                    >
                      Mailbox automatica: non configurata (admin)
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
